import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostPatientSubscriptionCancelBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function usePostPatientSubscriptionCancel(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostPatientSubscriptionCancelBody) =>
      dataOrThrow(
        await api.post('/patients/:patientId/subscription/cancel', {
          params: { patientId },
          body,
        })
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', patientId] })
      queryClient.invalidateQueries({
        queryKey: ['cancellation-quote', patientId],
        refetchType: 'none',
      })
      queryClient.invalidateQueries({
        queryKey: ['cancellation-options', patientId],
        refetchType: 'none',
      })
    },
  })
}
